import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

// The template editor preview shows every field so the whole template can be reviewed, even the date and method of
// the response that stay hidden until the response is known to be sent.
export function showsResponseDetails(answer: YesNoAnswer | null | undefined, isPreview: boolean) {
    return isPreview || answer === YesNoAnswer.Yes;
}
